import React, { useContext } from "react";
import loginbg from "../images/loginbg.png";
// import gpt from "../images/gpt.png";
import getdoc from "../images/getdoc.png";
import findans from "../images/findans.png";
import research from "../images/research.png";
import comdoc from "../images/comdoc.png";
import roleContext from "../contexts/roleContext";

const WelcomeLogin = () => {
  const context = useContext(roleContext);

  return (
    <div>
      <img
        src={loginbg}
        alt="bg"
        className="h-screen p-5 absolute w-[-webkit-fill-available]"
      />
      <div className="flex justify-center items-center h-screen">
        <div className="flex items-center justify-center flex-col gap-5 pt-26 pb-10 bg-white w-fit relative rounded-3xl px-10 py-14">
          {/* <img src={gpt} alt="gpt" /> */}
          {/* <h1 className="text-3xl font-cerebrisemibold">{context?.company}</h1> */}
          <h1 className="text-[#201F29] text-[24px] font-cerebribold leading-[32px]">
            Welcome to <span style={{
              background:
                "linear-gradient(90deg, #3D1DFF, #D94FE8, #EF5B8D, #FFCB8C)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
            }}> {context?.company} </span>
          </h1>
          <p className="text-[#585858] text-[14px] font-cerebriregular leading-[22px] text-center">
            {context?.company} is your personal AI-powered assistant, ready to
            help <br /> you with any documents, so you can make better
            decisions.
          </p>
          <div className="flex flex-col gap-5">
            <div className="flex items-center gap-2">
              <img src={getdoc} alt="getdoc" />
              <h1 className="text-[#201F29] text-[14px] font-cerebribold leading-[22px]">
                Get document summaries
              </h1>
            </div>
            <div className="flex items-center gap-2">
              <img src={findans} alt="findans" />
              <h1 className="text-[#201F29] text-[14px] font-cerebribold leading-[22px]">
                Find answers to questions
              </h1>
            </div>
            <div className="flex items-center gap-2">
              <img src={research} alt="research" />
              <h1 className="text-[#201F29] text-[14px] font-cerebribold leading-[22px]">
                Understand research
              </h1>
            </div>
            <div className="flex items-center gap-2">
              <img src={comdoc} alt="comdoc" />
              <h1 className="text-[#201F29] text-[14px] font-cerebribold leading-[22px]">
                Compare documents{" "}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeLogin;
